import { useNavigate } from "react-router-dom";
import useGetDashboard from "../../../../hooks/queries/admin/useGetDashboard";
import ErrorPage from "../../../../components/ErrorPage";
import Loader from "../../../../components/Loader";
import ProgramNotLive from "./ProgramNotLive";
import ProgramLive from "./ProgramLive";
import { PageContainer, ContentContainer, HeaderGradient } from "../components";
import { adminOnboardingFullPath } from "../../../../routes/paths";
import useGetMe from "../../../../hooks/queries/useGetMe";

type Props = {};

const Home = (props: Props) => {
  const navigate = useNavigate();
  const { data: meData } = useGetMe();
  const { data, status } = useGetDashboard({
    onSuccessHandler: () => {
      if (data && !data.is_onboarding_complete) {
        navigate(adminOnboardingFullPath);
      }
    },
  });

  if (status === "loading") {
    return <Loader />;
  }

  if (status === "error") {
    return <ErrorPage />;
  }

  return (
    <PageContainer>
      <HeaderGradient
        title={`Emergency Savings Platform ${
          meData?.employer.name ? `- ${meData?.employer.name}` : ""
        }`}
        subtitle="Helping your employees save for unexpected expenses and financial emergencies"
      />
      <ContentContainer>
        {data.is_program_live ? (
          <ProgramLive data={data} />
        ) : (
          <ProgramNotLive data={data} />
        )}
      </ContentContainer>
    </PageContainer>
  );
};

export default Home;
